import { createContext } from 'react'
import type { DashboardStatsContextValue } from '@/types'

export const DashboardStatsContext = createContext<
  DashboardStatsContextValue | undefined
>(undefined)
